<template>
  <span class="label" :class="getClasses()" :title="getTitle()">{{ getLabel() }}</span>
</template>

<script>
  export default{
    name: 'ClientStatus',
    props: ['client', 'classes'],
    components: {},
    data () {
      return {}
    },
    mounted () {},
    methods: {
      getTitle () {
        let title = ''
        if (this.client.company_client.employee) title += this.client.company_client.employee
        return title
      },
      getLabel () {
        if (this.client.company_client.status === 0 && this.client.company_client.active === 1) return 'EM ANÁLISE'
        if (this.client.company_client.status === 2 && this.client.company_client.active === 1) return 'REPROVADO'
        if (this.client.company_client.status === 1 && this.client.company_client.active === 1) return 'APROVADO'
        if (this.client.company_client.active === 0) return 'BLOQUEADO'
      },
      getClasses () {
        let classes = this.classes || ''
        if (this.client.company_client.status === 0 && this.client.company_client.active === 1) return 'label-warning ' + classes
        if (this.client.company_client.status === 2 && this.client.company_client.active === 1) return 'label-danger ' + classes
        if (this.client.company_client.status === 1 && this.client.company_client.active === 1) return 'label-success ' + classes
        if (this.client.company_client.active === 0) return 'label-danger ' + classes
      }
    }
  }
</script>


// WEBPACK FOOTER //
// ClientStatus.vue?d87c0952